/**
 * @generated SignedSource<<e1eed561c926631305a39d64c0417d5c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LinkSlide_slide",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "type": "Slide",
  "abstractKey": null
};

node.hash = "5fe3f51b70a3b8fdaece0a2dd9145030";

module.exports = node;
